import React from 'react';
import type { Moment } from 'moment';
import DateRangePicker from '@this/src/components/arrangement/todo_list/date_range_picker';

interface Props {
  reservationDateFrom?: Moment;
  reservationDateTo?: Moment;
  setReservationDateFrom: (reservationDateFrom?: Moment) => void;
  setReservationDateTo: (reservationDateTo?: Moment) => void;
}

const SearchArea: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div
    style={{
      display: 'flex',
      backgroundColor: '#f7f7f7',
      padding: '10px',
      flexWrap: 'wrap',
      marginBottom: '10px'
    }}
  >
    {children}
  </div>
);

const SearchBlock: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px', marginBottom: '5px' }}>{children}</div>
);

const SearchLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={{ fontWeight: 'bold', marginRight: '5px' }}>{children}</div>
);

const TotalSearchArea: React.FC<Props> = ({
  reservationDateFrom,
  reservationDateTo,
  setReservationDateFrom,
  setReservationDateTo
}) => {
  return (
    <SearchArea>
      <SearchBlock>
        <SearchLabel>予約日</SearchLabel>
        <DateRangePicker
          from={reservationDateFrom}
          to={reservationDateTo}
          onFromChange={d => setReservationDateFrom(d)}
          onToChange={d => setReservationDateTo(d)}
        />
      </SearchBlock>
    </SearchArea>
  );
};

export default TotalSearchArea;
